/* eslint-disable vue/component-name-in-template-casing */
import Admin from "@/pages/Admin";
import ChannelsAdmin from "@/pages/admin/Channels";
import CoursesAdmin from "@/pages/admin/Courses";
import CoursesInstall from "@/pages/admin/AdminCourses";
import ManageCourse from "@/pages/admin/Managecourse";
import FinanceAdmin from "@/pages/admin/Finance";
import GroupsAdmin from "@/pages/admin/Groups";
import HelpAdmin from "@/pages/admin/Help";
import MarketplaceAdmin from "@/pages/admin/Marketplace";
import ReportsAdmin from "@/pages/admin/Reports";
import UserReport from "@/pages/admin/reports/User";
import PlaylistReport from "@/pages/admin/reports/Playlist";
import GroupReport from "@/pages/admin/reports/Group";
import CourseReport from "@/pages/admin/reports/Course";
import CourseReportDetails from "@/pages/admin/reports/CourseDetails";
import UsersAdmin from "@/pages/admin/Users";
import ManageUsers from "@/pages/admin/course/ManageUsers";
import Organise from "@/pages/admin/channels/Organise";
import TestAdmin from "@/pages/admin/course/TestAdmin";
import FAQ from "@/pages/admin/help/Faqs";
import ExternalTrainingReport from "@/pages/admin/reports/ExternalTraining";
import CourseDetail from "@/pages/admin/ShowCourseDetail";
import CourseIndividualReport from "@/pages/admin/CourseReport";
import ArchivedUsers from "@/pages/admin/ArchivedUsers";
import ArchivedUserReport from "@/pages/admin/reports/ArchivedUser";
import UserCourseReport from "@/pages/admin/reports/UserCourse";
import Settings from "@/pages/admin/Settings";
import Passwordreset from "@/pages/public/Passwordreset";
import CompanyInfo from "@/pages/admin/finance/CompanyInformation";
import AccountStatus from "@/pages/admin/finance/AccountStatus";
import PlaylistCourseReport from "@/pages/admin/reports/PlaylistCourse";
import CourseNotifications from "@/pages/admin/CourseNotifications";

const routes = [
  {
    path: "/admin",
    name: "Admin",
    component: CoursesAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/playlists",
    name: "Playlist Admin",
    component: ChannelsAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Playlists",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/help/faq",
    name: "FAQ's",
    component: FAQ,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "FAQ's",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/playlists/organise/:id",
    name: "Manage Course Playlists",
    component: Organise,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Playlists",
          disabled: false,
          href: "/admin/playlists"
        },
        {
          text: "Manage Courses",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/courses/test/:id",
    name: "Manage Courses",
    component: TestAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/admin/courses"
        },
        {
          text: "Test Admin",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/courses",
    name: "Courses Admin",
    component: CoursesAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Courses",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/install-courses",
    name: "Install Courses",
    component: CoursesInstall,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Install Courses",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/courses/:id",
    name: "Manage Course",
    component: ManageCourse,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/admin/courses"
        },
        {
          text: "Manage Course",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/courses/:id/users",
    name: "Manage Users",
    component: ManageUsers,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/admin/courses"
        },
        {
          text: "Manage Users",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/finance",
    name: "Finance",
    component: FinanceAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Finance",
          disabled: true
        }
      ],
      public: false,
      admin: true,
      suspendedAccessible: true
    }
  },
  {
    path: "/admin/groups",
    name: "Groups Admin",
    component: GroupsAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Groups",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/help",
    name: "Help",
    component: HelpAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Help",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/marketplace",
    name: "Marketplace",
    component: MarketplaceAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Marketplace",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports",
    name: "Reports",
    component: ReportsAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports/user",
    name: "User Reports",
    component: UserReport,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports"
        },
        {
          text: "Users",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports/playlist",
    name: "Playlist Reports",
    component: PlaylistReport,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports"
        },
        {
          text: "Playlists",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports/group",
    name: "Group Reports",
    component: GroupReport,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports"
        },
        {
          text: "Groups",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports/course",
    name: "Course Reports",
    component: CourseReport,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports"
        },
        {
          text: "Courses",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports/course/:id",
    name: "Single Course Reports",
    component: CourseReportDetails,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/admin/reports/course"
        },
        {
          text: "Details",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/reports/external-training",
    name: "External Training Reports",
    component: ExternalTrainingReport,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports"
        },
        {
          text: "External Training",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/users",
    name: "Users",
    component: UsersAdmin,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Users",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/courses/detail/:id",
    name: "Course Detail",
    component: CourseDetail,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/courses-report/:id",
    name: "Course Report",
    component: CourseIndividualReport,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/archived-users",
    name: "Archived Users",
    component: ArchivedUsers,
    meta: {
      breadcrumb: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin"
        },
        {
          text: "Archived Users",
          disabled: true
        }
      ],
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/user-report/:id",
    name: "Archived User Report",
    component: ArchivedUserReport,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/user-course-report/:id",
    name: "User Course Report",
    component: UserCourseReport,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/settings",
    name: "Settings",
    component: Settings,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/password-reset",
    name: "Password Resets",
    component: Passwordreset,
    meta: {
      public: true
    },
  },
  {
    path: "/admin/finance/company",
    name: "Company Information",
    component: CompanyInfo,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/finance/account-status",
    name: "Account Status",
    component: AccountStatus,
    meta: {
      public: false,
      admin: true,
      suspendedAccessible: true
    }
  },
   {
    path: "/admin/playlist-course-report/:id",
    name: "Playlist Course Report",
    component: PlaylistCourseReport,
    meta: {
      public: false,
      admin: true
    }
  },
  {
    path: "/admin/course-notification/:id",
    name: "Course Notifications",
    component: CourseNotifications,
    meta: {
      public: false,
      admin: true
    }
  },
];

export default routes;
